import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AccountSharedModule } from '@app/account/account-shared.module';
import { PaymentCheckoutWizardModule } from '@app/account/shared/payment-checkout-wizard/payment-checkout-wizard.module';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { UserServiceCardFullModule } from '@app/meetings/user-service-card-full/user-service-card-full.module';
import { TeacherBookingSurfaceBlockComponent } from '@app/teachers/teacher-card/teacher-booking-surface-block/teacher-booking-surface-block.component';
import { TeacherCardComponent } from '@app/teachers/teacher-card/teacher-card.component';
import { UsersModule } from '@app/users/users.module';
import { BookmarkComponent } from '@core/components/bookmark/bookmark.component';
import { HorizontalScrollMenuModule } from '@core/components/horizontal-scroll-menu/horizontal-scroll-menu.module';
import { MeetingReviewModule } from '@core/components/meeting-review/meeting-review.module';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { ReviewsCarouselModule } from '@core/components/reviews-carousel/reviews-carousel.module';
import { UserServiceCardModule } from '@core/components/service-card/user-service-card.module';
import { SubscribeComponent } from '@core/components/subscribe/subscribe.component';
import { PipesModule } from '@core/pipes/pipes.module';

import { ComplaintFormModule } from '@shared/complaint-form/complaint-form.module';
import { IconComponent } from '@shared/icon/icon.component';
import { RatingComponent } from '@shared/rating/rating.component';
import { DateFnsModule } from 'lingo2-ngx-date-fns';
import { ClickOutsideModule } from 'ng-click-outside';
import { OnUiButtonModule, OnUiCardMenuModule, OnUiCoverModule } from 'onclass-ui';

@NgModule({
  declarations: [TeacherCardComponent],
  imports: [
    LocaleSharedModule,
    CommonModule,

    RouterModule,
    AccountSharedModule,
    UsersModule,
    MobileModalModule,
    ModalModule,
    PipesModule,
    DateFnsModule,
    ClickOutsideModule,
    ComplaintFormModule,
    MeetingReviewModule,
    ReviewsCarouselModule,
    UserServiceCardModule,
    HorizontalScrollMenuModule,
    OnUiCardMenuModule,
    UserServiceCardFullModule,
    OnUiCoverModule,
    OnUiButtonModule,
    PaymentCheckoutWizardModule,
    IconComponent,
    BookmarkComponent,
    SubscribeComponent,
    TeacherBookingSurfaceBlockComponent,
    RatingComponent,
  ],
  exports: [TeacherCardComponent],
})
export class TeacherCardModule {}
